import React from 'react';

import { PAGE_TITLE } from '../../constants';
import Component from '../../components/schools';
import Container from '../../containers/admin';
import Root from '../../components/root';

export default function PageSchools() {
  return (
    <Root title={PAGE_TITLE.SCHOOLS}>
      <Container>
        <Component />
      </Container>
    </Root>
  );
};
